import styled from "styled-components";
import { PlanBlock } from "../../components/PlanBlock";
import { lightTheme } from "../../styles/theme";
import { openInNewTab } from "../../utils/openInNewTab";
import { useTranslation } from "../../lang/TranslationContext";
import { AnimateIn } from "../../components/AnimateIn";

export const Plans = () => {
  const { translations } = useTranslation();

  return (
    <Wrap>
      <Top>
        <h1>{translations.landing.plans.heading}</h1>
        <p>{translations.landing.plans.subheading}</p>
      </Top>
      <Middle>
        <AnimateIn direction="right">
          <PlanBlock isFree countOfAssets={3} />
        </AnimateIn>
        <AnimateIn>
          <PlanBlock
            dailyPrice={{ dollars: 0, cents: 99 }}
            montlyPrice="29.99"
            countOfAssets={1}
          />
        </AnimateIn>
        <AnimateIn>
          <PlanBlock
            isPopular
            dailyPrice={{ dollars: 1, cents: 83 }}
            montlyPrice="54.99"
            countOfAssets={5}
          />
        </AnimateIn>
        <AnimateIn direction="left">
          <PlanBlock
            isBestValue
            dailyPrice={{ dollars: 3, cents: 33 }}
            montlyPrice="99.99"
            countOfAssets={14}
          />
        </AnimateIn>
      </Middle>
      <Bottom onClick={() => openInNewTab("https://marketecho.app/signup")}>
        <p>{translations.landing.plans.action}</p>
      </Bottom>
    </Wrap>
  );
};

const Wrap = styled.div`
  width: 100%;
  background: #141d1b;
  padding: 32px 10px 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 744px) {
    padding: 32px 20px 60px;
  }
`;

const Default = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Top = styled(Default)`
  h1 {
    font-size: 42px;
    font-weight: 700;
    color: #ffffff;
    text-align: center;
  }
  p {
    margin-top: 16px;
    font-size: 18px;
    font-weight: 400;
    color: ${lightTheme.typography.secondary};
    max-width: 900px;
    text-align: center;
    line-height: 1.6;
    padding: 0 24px;
  }

  @media screen and (max-width: 744px) {
    h1 {
      font-size: 28px;
    }

    p {
      font-size: 15px;
    }
  }
`;

const Middle = styled(Default)`
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  gap: 60px;
  margin-top: 32px;

  @media screen and (max-width: 744px) {
    gap: 25px;
  }
`;

const Bottom = styled(Default)`
  p {
    color: #afafaf;
    font-weight: 500;
    text-decoration: underline;
    text-align: center;
    font-size: 12px;
    margin-top: 34px;
    transition: 0.2s;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }
`;
